import React, { useContext, useCallback } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { setTheme } from '../../../helpers';
import ThemeContext from '../../../contexts/ThemeContext';

export const Toggle = ({
  defaultLabel,
  defaultIcon,
  toggledLabel,
  toggledIcon,
  ...props
}) => {
  const [themeName, setThemeName] = useContext(ThemeContext);

  const toggleTheme = useCallback(
    (e) => {
      e.preventDefault();
      const newTheme = themeName === 'light' ? 'dark' : 'light';

      setThemeName(newTheme);
      setTheme(newTheme);
    },
    [themeName, setThemeName]
  );

  return (
    <ClicToggle onClick={(event) => toggleTheme(event)}>
      <Span className={themeName === 'light' && 'active'}>
        {defaultIcon}
        {defaultLabel}
      </Span>
      <Span className={themeName === 'dark' && 'active'}>
        {toggledIcon}
        {toggledLabel}
      </Span>
    </ClicToggle>
  );
};

Toggle.propTypes = {
  defaultLabel: PropTypes.string,
  defaultIcon: PropTypes.object,
  toggledLabel: PropTypes.string,
  toggledIcon: PropTypes.object,
};

Toggle.defaultProps = {
  defaultLabel: 'Light',
  toggledLabel: 'Dark',
};

const ClicToggle = styled.button`
  display: flex;
  align-items: center;
  margin: 10px 20px;
  padding: 4px 3px;
  background: ${(props) =>
    props.theme.name === 'light'
      ? `${props.theme.color.grey5}`
      : `${props.theme.color.black75}`};
  border: none;
  border-radius: 12px;
  cursor: pointer;
`;

const Span = styled.span`
  display: flex;
  align-items: center;
  padding: 5px 23px;
  border-radius: 12px;
  font-size: 16px;
  line-height: 24px;
  flex: 1;
  color: ${(props) =>
    props.theme.name === 'light'
      ? `${props.theme.color.grey75}`
      : `${props.theme.color.grey50}`};
  svg {
    margin-right: 8px;
    > path {
      fill: ${(props) =>
        props.theme.name === 'light'
          ? `${props.theme.color.grey75}`
          : `${props.theme.color.grey50}`};
    }
  }
  &.active {
    ${(props) => props.theme.fontBold};
    font-weight: 500;
    background: ${(props) =>
      props.theme.name === 'light'
        ? `${props.theme.color.whiteFull}`
        : `${props.theme.color.black90}`};

    box-shadow: ${(props) =>
      props.theme.name === 'light'
        ? '0px 4px 8px rgba(0, 0, 0, 0.05), 0px 2px 4px rgba(0, 0, 0, 0.05);'
        : '0px 4px 8px rgba(0, 0, 0, 0.05), 0px 2px 4px rgba(0, 0, 0, 0.05);'};
    color: ${(props) =>
      props.theme.name === 'light'
        ? `${props.theme.color.black90}`
        : `${props.theme.color.whiteFull}`};
    svg > path {
      fill: ${(props) =>
        props.theme.name === 'light'
          ? `${props.theme.color.black90}`
          : `${props.theme.color.whiteFull}`};
    }
  }
`;
